import update from 'immutability-helper';
import * as types from './types';

export interface IState {
  bucket: string;
  time: string;
  highlightBucket: string;
  legends: object;
}

const initialState: IState = {
  bucket: '',
  time: '',
  highlightBucket: '',
  legends: {},
};

const switchMap: {
  [key in keyof typeof types]?: (state: IState, action: Partial<{ type: keyof typeof types }>) => string;
} = {};

switchMap[types.INIT] = (state) => update(state, {
  $set: initialState,
});

switchMap[types.SET_BUCKET_TIME] = (state, action) => update(state, {
  $merge: {
    bucket: action.bucket,
    time: action.time,
  },
});

switchMap[types.SET_LEGENDS] = (state, action) => update(state, {
  $merge: {
    legends: action.legends,
  },
});

switchMap[types.RESET_LEGENDS] = state => update(state, {
  $merge: {
    legends: {}
  },
});

switchMap[types.SET_HIGHLIGHT_BUCKET] = (state, action) => update(state, {
  highlightBucket: {
    $set: action.bucket
  },
});

switchMap[types.REST_BUCKET_TIME] = (state) => update(state, {
  $merge: {
    bucket: '',
    time: '',
  },
});

switchMap[types.INJECT_SHARED_STATE] = (state, action) => update(state, {
  $merge: action.sharing,
});

export default (state = initialState, action) => (
  switchMap[action.type]
    ? switchMap[action.type](state, action)
    : state
);
